module.exports = __webpack_public_path__ + "img/szz.f06a5bc0.png";